



























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { productCategoryList } from '@/api/product';
import request from '@/utils/request';
// interface SelectorModel {
//   id: string;
//   parentId: string;
//   name: string;
//   items: Array<SelectorModel>;
//   isStatic: boolean;
//   isSelected: boolean;
// }

@Component({
  name: 'ams-product-category-selector'
})
export default class AMSProductCategorySelector extends Vue {
  menuVisible: boolean = false;
  items: Array<any> = [];
  showItems: Array<any> = [];
  selectItem: any = null;
  /**是否正在获取分类 */
  isLoading: boolean = false;
  /**请求接口 /api/Product/category/list*/
  @Prop({ default: '/api/Product/category/All' }) api!: string;
  /**文本框宽度 */
  @Prop({ default: 'auto' }) width!: string;
  @Prop() inputClass!: string;

  /**文本框高度 */
  @Prop({ default: 'auto' }) height!: string;
  /**表单验证规则 */
  @Prop({
    default: () => {
      return [];
    }
  })
  rules!: Array<any>;
  /**是否需要全部这个选项 */
  @Prop({ default: true }) needAllItem!: boolean;
  /**是否需要选到最后一个 */
  @Prop({ default: false }) needSelectLastOne!: boolean;
  /**是否需要展示placeholder */
  @Prop({ default: false }) needShowPlaceHolderOnInit!: boolean;
  @Prop({ default: '请选择商品分类' }) placeholder?: string;

  /**v model */
  @Prop({ default: '' }) value!: string | number;
  @Prop({ default: '' }) label?: string;

  /**禁用的数组里面的item */
  @Prop({
    default: function() {
      return [];
    }
  })
  disableItems!: any[];
  /**用于显示所选择的分类的拼接文字 */
  displayText: string = '';

  onEnter() {
    const text = this.$refs.categoryText as any;
    if (text) {
      text.blur();
    }
  }

  created() {}

  mounted() {}

  allItem() {
    return { id: '-1', name: '全部', isSelected: false, parentId: '' };
  }

  /**文本框样式 */
  get textStyle() {
    return `width:${this.width};height:${this.height}`;
  }

  /**显示选中的item */
  get name() {
    return this.displayText ? this.displayText : this.needShowPlaceHolderOnInit ? '' : this.allItem().name;
  }

  /**显示箭头 */
  get appendIcon() {
    if (this.selectItem && this.selectItem.id != this.allItem().id) {
      return 'clear';
    } else {
      return this.menuVisible ? 'arrow_drop_up' : 'arrow_drop_down';
    }
  }

  get showClose() {
    return this.selectItem && this.selectItem.id != this.allItem().id;
  }

  get arrowIcon() {
    return this.menuVisible ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  onAppendClick(event: any) {
    if (this.selectItem && this.selectItem.id != this.allItem().id) {
      this.displayText = '';
      this.selectItem = null;

      this.$emit('input', '');
    } else {
      this.menuVisible = !this.menuVisible;
    }
  }

  /**获取分类数据 */
  getCategory() {
    this.isLoading = true;
    request
      .get(this.api)
      .then((response: any) => {
        this.isLoading = false;
        if (response != null && response.length > 0) {
          this.items = response;
          this.checkIsCategoryIdExist();
          this.disableTargetItems();

          if (this.selectItem) {
            this.displayText = '';
            this.generateDisplayText(this.selectItem);
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
        // this.isLoading = false;
      });
  }

  clear() {
    this.selectItem = null;

    this.$emit('input', '');
  }

  /**查看category id 是否存在 如果存在就选中 */
  checkIsCategoryIdExist() {
    const categoryId = this.$props.value;

    this.flatten(this.items, '');

    if (categoryId && categoryId != '') {
      if (this.needAllItem) {
        const all = this.allItem();
        this.items.unshift(all);
      }
      //找到当前选中的item
      const item = this.recursion(this.items, categoryId);

      if (item) {
        if (item.parentId && item.parentId != '') {
          const ii = this.generateShowItems(this.flattenItems, item.parentId, categoryId);
        } else {
          //就是第一层的了，没有parent id
          this.showItems.push(this.items);
          this.showItems[0].map((v: any, i: number) => {
            if (v.id === categoryId) {
              v.isSelected = true;
            }
          });
        }
      } else {
        //找不到对应的item，证明那个categoryId不存在
        this.selectItem = null;
        this.showItems.push(this.items);
        this.showItems[0].map((v: any, i: number) => {
          if (v.id === categoryId) {
            v.isSelected = true;
          }
        });
      }
    } else {
      this.showItems.push(this.items);
      this.showItems[0].map((v: any, i: number) => {
        v.parentId = '';
        v.isSelected = false;
      });

      if (this.needAllItem) {
        const all = this.allItem();
        this.items.unshift(all);
      }
    }
  }

  flattenItems: any[] = [];

  flatten(data: any[], id: string) {
    //parentId
    for (const c of data) {
      c.parentId = id;
      this.flattenItems.push(c);
      if (c.items && c.items.length > 0) {
        this.flatten(c.items, c.id ? c.id : '');
      }
    }
  }

  generateShowItems(data: Array<any>, parentId: string, seletedId: string): any {
    var arr: any = [];
    data.map((v, i) => {
      if (v.parentId === parentId) {
        arr.push(v);
      }
      if (v.id === seletedId) {
        v.isSelected = true;
      }
    });

    if (arr.length > 0) {
      if (this.needAllItem) {
        if (arr.length > 1) {
          const all = this.allItem();
          // console.log(parentId + '----' + seletedId);
          all.parentId = parentId;
          arr.unshift(all);
        }
      }
      this.showItems.unshift(arr);
      const item = this.recursion(this.items, arr[this.needAllItem && arr.length > 1 ? 1 : 0].parentId);
      if (item) {
        this.generateShowItems(this.flattenItems, item.parentId, parentId);
      }

      // return arr;
    } else {
      // return [];
    }
  }

  recursion(data: Array<any>, current: string): any {
    if (!data) {
      return null;
    }
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (element.id === current) {
        return element;
      } else if (element.items && element.items.length > 0) {
        const item: any = this.recursion(element.items, current);
        if (item) {
          return item;
        }
      }
    }
    return null;
  }

  @Watch('menuVisible', { immediate: true, deep: true })
  onMenuVisibleChange(newValue: boolean, oldValue: boolean) {
    if (newValue == true) {
      // this.selectItem = null;
      this.showItems = [];
      this.flattenItems = [];
      if (this.items !== undefined && this.items !== null) {
        this.getCategory();
      }
    } else {
      if (this.selectItem === null && oldValue !== undefined) {
        this.$emit('input', '');
      }

      const text = this.$refs.categoryText as any;
      if (text) {
        text.focus();
      }
    }
  }

  @Watch('value', { immediate: true, deep: true })
  onValueChange(newValue: string, oldValue: string) {
    if (newValue == undefined || newValue == null || newValue === '') {
      this.selectItem = null;
      this.showItems = [];
      this.flattenItems = [];
      this.displayText = '';
    } else {
      this.selectItem = { id: newValue };
      if (this.items && this.items.length) {
        this.displayText = '';
        this.generateDisplayText(this.selectItem);
      } else {
        if (this.isLoading != true) {
          this.showItems = [];
          this.flattenItems = [];
          this.displayText = '';
          this.getCategory();
        }
      }
    }
  }

  /**点击了某一项 */
  onItemClick(item: any, index: number, col: number) {
    if (item.disable) return;
    /**是否需要选到最后一级 */
    if (this.needSelectLastOne) {
      if (item.items != null && item.items.length > 0) {
      } else {
        // this.displayText ="666666";
        this.selectItem = item;

        if (this.selectItem) {
          this.displayText = '';
          this.generateDisplayText(this.selectItem);
        }

        this.$emit('input', item.id == this.allItem().id ? item.parentId : item.id, this.displayText);
        this.menuVisible = false;
      }
    } else {
      this.selectItem = item;

      if (this.selectItem) {
        this.displayText = '';
        this.generateDisplayText(this.selectItem);
      }

      this.$emit('input', item.id == this.allItem().id ? item.parentId : item.id, this.displayText);
      this.menuVisible = false;
    }

    // if (col + 1 <= this.showItems.length - 1) {
    //   const start = col + 1;
    //   const count = this.showItems.length - (col + 1);
    //   this.showItems.splice(start, count);
    // } else {
    //   this.showItems.splice(col + 1, 1);
    // }
    // if (item.items != null && item.items.length > 0) {
    //   item.items.map((v: any, i: number) => {
    //     v.isSelected = false;
    //   });
    //   this.showItems.push(item.items);
    // } else {
    //   //选中了最末尾的一个
    //   this.$emit('input', item.id == '-1' ? '' : item.id);
    //   this.$emit('onSelectItem', item);
    //   this.selectItem = item;
    //   this.menuVisible = false;
    // }
    // const sameLevelItemArray = this.showItems[col];
    // sameLevelItemArray.map((v: any, i: number) => {
    //   if (v.id != item.id) {
    //     v.isSelected = false;
    //   }
    // });
    // item.isSelected = true;
  }

  /**获取展示在界面上的文字 */
  generateDisplayText(item: any) {
    if (!item) return;

    if (this.items.length > 0 && this.flattenItems.length <= 0) {
      this.flattenItems = [];
      this.flatten(this.items, '');
    }

    this.flattenItems.forEach((v: any, i: any) => {
      if (item.id == v.id) {
        //console.log('拼接前:' + this.displayText);
        this.displayText = this.displayText == '' ? v.name : v.name + '-' + this.displayText;
        //console.log('拼接后:' + this.displayText);
        item.parentId = v.parentId;
      } else {
      }
    });

    if (item.parentId && item.parentId != '') {
      const parent: any = this.recursion(this.flattenItems, item.parentId);
      if (parent) {
        this.generateDisplayText(parent);
      }
    }
  }

  /**鼠标移动到item上面 */
  onMouseOverItem(item: any, index: number, col: number) {
    if (col + 1 <= this.showItems.length - 1) {
      const start = col + 1;
      const count = this.showItems.length - (col + 1);
      this.showItems.splice(start, count);
    } else {
      this.showItems.splice(col + 1, 1);
    }

    const items = this.showItems[col];
    items.map((v: any) => {
      v.isSelected = v.id == item.id;
    });
    this.showItems[col] = items;

    if (item.items != null && item.items.length > 0) {
      item.items.map((v: any, i: number) => {
        v.parentId = item.id;
        v.isSelected = false;
      });

      const first = item.items[0];
      if (first.id != this.allItem().id && this.needAllItem) {
        //&& item.items.length > 1
        let all = this.allItem();
        all.parentId = item.id; //item.parentId == '' || item.parentId == undefined ? item.id : item.parentId;
        item.items.unshift(all);
      }

      this.showItems.push(item.items);
    } else {
    }

    //禁用指定item
    this.disableTargetItems();
  }

  /**开始滚动到指定位置 */
  startScrollToTarget() {
    this.showItems.map((item, i) => {
      item.map((o: any, j: any) => {
        if (o.isSelected == true) {
          this.scrollToIndex(j, i);
        }
      });
    });
  }

  /**滚动到指定行 */
  scrollToIndex(index: number, col: number) {
    const elements: any[] = this.$refs[`list${col}`] as any[];
    if (elements && elements.length > 0) {
      const element = elements[0] as HTMLElement;
      const list = element.firstElementChild;
      if (list) {
        list!.scrollTop = index * 48;
      }
    }
  }

  @Watch('disableItems', { immediate: true, deep: true })
  onDisableItemsChange(newValue: string, oldValue: string) {}
  /**禁用相应的item */
  disableTargetItems() {
    if (this.disableItems.length > 0) {
      this.showItems.map((items: any, i: any) => {
        items.map((item: any, j: any) => {
          if (this.disableItems.indexOf(item.id) != -1) {
            item.disable = true;
          }
        });
      });
    }
  }
}
